module.exports = __webpack_public_path__ + "media/scholarships/stellar-score_60x46-76aa97b7.png";